<template>
  <div class="">
    <button v-b-modal.export-user-setting class="btn btn-primary mx-1 rounded-pill">خروجی از
      کاربران
    </button>


    <b-modal id="export-user-setting" hide-footer>
      <div class="text-right" dir="rtl">
        <h5>خروجی کاربران</h5>

        <div class="col-12 text-center">
          <button class="mx-1 btn btn-primary btn-primary" @click="exportUsers()">خروجی کامل</button>
          <button class="mx-1 btn btn-primary btn-primary" @click="exportUsers('cellphone')">خروجی شماره ها</button>
        </div>

      </div>
    </b-modal>
  </div>

</template>

<script>
export default {
  name: "ExportUsers",
  methods: {
    filterObjectByKeys(obj, keys) {
      return Object.keys(obj)
          .filter(key => keys.includes(key))
          .reduce((res, key) => {
            res[key] = obj[key];
            return res;
          }, {});
    },

    async exportUsers(userKeys = ['name', 'last_name', 'cellphone']) {
      let data = await this.$store.dispatch('User/exportUsers');
      let users = data.data.data

      // convert each object to one line
      let result = []
      users.forEach(item => {
        let joinValueOfObject = this.filterObjectByKeys(item, userKeys)
        joinValueOfObject = Object.values(joinValueOfObject).join(", ");
        result.push(joinValueOfObject)
      })


      // Step 1: Convert the array to a string
      const text = result.join('\n');

      // Step 2: Create a Blob from the string
      const blob = new Blob([text], {type: 'text/plain'});

      // Step 3: Create a URL for the Blob
      const url = URL.createObjectURL(blob);

      // Step 4: Create a temporary anchor element
      const a = document.createElement('a');
      a.href = url;
      a.download = 'array.txt';

      // Step 5: Trigger a click event to initiate the download
      document.body.appendChild(a);
      a.click();

      // Step 6: Clean up
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

    }
  },
  mounted() {

  }
}
</script>


<style scoped>

</style>